import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { Common } from "../../../api";

export const commonKeys = {
  countries: () => ["countries"]
};

export function useGetCountries(config) {
  const { callApi } = useAuth();
  return useQuery(commonKeys.countries(), () => callApi(Common.getCountries), config);
}

/**
 * 
 * @param {UseQueryOptions} config 
 * @returns 
 */
export function useGetAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId }) =>
    callApi(Common.getAttachment, { attachmentId }), config);
}

export function useDeleteAttachment(config) {
  const { callApi } = useAuth();
  return useMutation(({ attachmentId }) =>
    callApi(Common.deleteAttachment, { attachmentId }), config);
}